import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'A workspace saved size was deleted',
  name: 'saved_size_deleted',
  params: [
    {
      description: 'Where the deletion was made from',
      name: 'source',
      required: true,
      type: 'enum',
      values: ['context'],
    },
  ],
};

export default META;
